import AxiosClient from "../../../services/axios.services";

class CompetenciesServices {
  getCompetencies = params =>
    AxiosClient.get("/api/app/descriptor_perfil_competencia_descriptor/", {
      headers: { "Content-Type": "application/json" },
      params: params,
    });
  getCompetencie = id =>
    AxiosClient.get(`/api/app/descriptor_perfil_competencia_descriptor/${id}/`, {
      headers: { "Content-Type": "application/json" },
  });
  // saveCompetencie = req =>
  //   AxiosClient.post("/api/app/descriptor_perfil_competencia_descriptor/", req, {
  //     headers: { "Content-Type": "application/json" },
  //   });
  // editCompetencie = (id, req) =>
  //   AxiosClient.put(`/api/app/descriptor_perfil_competencia_descriptor/${id}/`, req, {
  //     headers: { "Content-Type": "application/json" },
  //   });
  saveCompetencie = req =>
    AxiosClient.post("/api/app/descriptor_perfil_competencia_descriptor_correccion/", req, {
      headers: { "Content-Type": "application/json" },
    });
  editCompetencie = (id, req) =>
    AxiosClient.put(`/api/app/descriptor_perfil_competencia_descriptor_correccion/${id}/`, req, {
      headers: { "Content-Type": "application/json" },
    });
  editCompetencieXCompetencieType = (id, req) =>
    AxiosClient.put(`/api/app/descriptor_perfil_competencia_descriptor/${id}/`, req, {
      headers: { "Content-Type": "application/json" },
    });
  deleteCompetencie = id =>
    AxiosClient.delete(`/api/app/descriptor_perfil_competencia_descriptor/${id}`, {
      headers: { "Content-Type": "application/json" },
    });
  saveCompetencieDoc = req => AxiosClient.post(`/api/app/descriptor_perfil_competencia_descriptor_archivo/`, req, {
    headers: { "Content-Type": "application/json" },
  });
}

export default new CompetenciesServices();